import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { store } from 'store/store';
import { DEPEND_CONDITION_RULES } from './DependencyService';

const SUBMIT_ERROR_ID = 'SUBMIT_INSURANCE_ERROR';

const isValid = (rule: ContentDependency, actualValue: string): boolean => {
	if (rule.dependCondition !== DEPEND_CONDITION_RULES.EMPTY) {
		if (actualValue === undefined || actualValue === null) {
			return false;
		}
		if (rule.dependValue === undefined || rule.dependValue === null) {
			return true;
		}
	}
	switch (rule.dependCondition) {
		case DEPEND_CONDITION_RULES.EMPTY:
			return !actualValue || actualValue?.trim() === '';
		case DEPEND_CONDITION_RULES.EQUALS:
			return actualValue === rule.dependValue;
		case DEPEND_CONDITION_RULES.NOT_EQUALS:
			return actualValue !== rule.dependValue;
		case DEPEND_CONDITION_RULES.GREATER_THAN:
			return parseInt(actualValue) > parseInt(rule.dependValue);
		case DEPEND_CONDITION_RULES.LESS_THAN:
			return parseInt(actualValue) < parseInt(rule.dependValue);
		case DEPEND_CONDITION_RULES.GREATER_THAN_OR_EQUAL_TO:
			return parseInt(actualValue) >= parseInt(rule.dependValue);
		case DEPEND_CONDITION_RULES.LESS_THAN_OR_EQUAL_TO:
			return parseInt(actualValue) <= parseInt(rule.dependValue);
		case DEPEND_CONDITION_RULES.CONTAINS:
			return actualValue.includes(rule.dependValue);
		case DEPEND_CONDITION_RULES.NOT_CONTAINS:
			return !actualValue.includes(rule.dependValue);
		case DEPEND_CONDITION_RULES.NOT_APPLICABLE:
			return !!actualValue;
		case DEPEND_CONDITION_RULES.MATCH_REGULAR_EXPRESSION:
			console.warn(DEPEND_CONDITION_RULES.MATCH_REGULAR_EXPRESSION, 'not implemented');
			return true; // NOT implemented
		default:
			return true;
	}
};

export const validateForm = (setValue: UseFormSetValue<FieldValues>, metaArea: MetaArea): boolean => {
	// clear submit error message
	const rules = metaArea.items[0].content?.validationRules?.items ?? [];
	setValue(SUBMIT_ERROR_ID, getFormErrorValue('NONE'));

	const form = store.getState().calculatorForm;
	let valid = true;
	rules.forEach((rule) => {
		if (!valid) {
			return;
		}
		const value = form[rule.content.dependsOn.uid]?.data?.value;
		if (!isValid(rule.content, value)) {
			setValue(SUBMIT_ERROR_ID, getFormErrorValue(rule.content.dependsOn.uid));
			valid = false;
		}
	});

	return valid;
};

export const setSubmitOpportunityError = (setValue: UseFormSetValue<FieldValues>) => {
	setValue(SUBMIT_ERROR_ID, getFormErrorValue('FAIL'));
};

const getFormErrorValue = (id: string) => {
	return {
		id: SUBMIT_ERROR_ID,
		value: id,
		type: 'SUBMIT_INSURANCE',
	};
};
